exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:960px){.view-main .navbar .open-panel{display:none}}", "", {"version":3,"sources":["/./src/App.vue"],"names":[],"mappings":"AAuDA,yBAEA,+BACI,YAAc,CACjB,CACA","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* style is not `scoped` so navbars in Pages are modified as well */\n@media (min-width: 960px) {\n  /* Let's hide panel-opener button when left panel is visible */\n.view-main .navbar .open-panel {\n    display: none;\n}\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-5f24868a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 312
// module chunks = 2